@if (showImage()) {
  <!--
    (error) matters: a logoUrl that 404s or decodes to nothing would otherwise leave the <img> in
    place drawing an empty circle, which reads as a broken page rather than as a store without a
    logo. Hydration replays it — `error` is one of the capture-phase events the replay contract
    records — so an image that fails before the client boots still flips to the name.

    `decoding="async"` only for lazy slots: they are off-screen by definition, so decoding off the
    main thread costs nothing there, while an eager slot (the hero, likely the LCP) keeps the
    browser's own choice.
  -->
  <img
    class="sav-store-logo-image"
    [src]="logoUrl()"
    [alt]="imageAlt()"
    [attr.loading]="loading()"
    [attr.decoding]="loading() === 'lazy' ? 'async' : null"
    (error)="onError()"
  />
} @else {
  <!--
    The whole store name, not initials — two letters say nothing about which brand this is. White
    ground, black text, sized to fit, so it reads as a plain wordmark rather than as a placeholder.
  -->
  <span
    class="sav-store-logo-fallback"
    [style.--sav-logo-fit]="fit()"
    [attr.aria-hidden]="decorative() ? 'true' : null"
  >
    <!--
      The text needs its own element. Line clamping requires display:-webkit-box, and that box
      model does not centre reliably on its block axis — which left the name sitting at the top of
      the circle. The outer span centres with flex; this one clamps.
    -->
    <span class="sav-store-logo-fallback-text">{{ name() }}</span>
  </span>
}
